module.exports = __webpack_public_path__ + "img/tiktok_logo_icon.d64998ba.svg";